const reportsColumns = [
  { label: 'Report Class', value: 'reportClass', disabled: true },
  { label: 'From', value: 'from', disabled: false },
  { label: 'To', value: 'to', disabled: false },
  { label: 'File Name', value: 'fileName', disabled: false },
  { label: 'Status', value: 'status', disabled: false },
  { label: 'Created', value: 'created', disabled: false },
  { label: 'Pending Since', value: 'pendingSince', disabled: false },
  { label: 'Processing At', value: 'processingAt', disabled: false },
  { label: 'Generated At', value: 'generatedAt', disabled: false },
  { label: 'Uploaded At', value: 'uploadedAt', disabled: false },
  { label: 'Upload URL', value: 'url', disabled: false },
  { label: 'Status Code', value: 'statusCode', disabled: false },
];

const deselectedByDefault = ['url', 'processingAt', 'pendingSince'];

export const defaultSelectedReportsColumns = reportsColumns
  .filter((column) => !deselectedByDefault.includes(column.value))
  .map((column) => column.value);

export default reportsColumns;
